<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">			
			<top-nevleft></top-nevleft>
		 <b-col>
			<!--<b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Sales Advisor Dashboard</h5>
				</b-col>				
			</b-row>-->
			
		<!-- <b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3 class="text-left">Share Links</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="redirectUrl('/user-roles')" v-if="$root.chkperm('userroles','enabled')">Manage Roles</b-button>
				</b-col>
			</b-row>
		</b-container> -->
		<b-container fluid class="mt-3 mb-2">
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12 p-0">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="lg" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(link_id)="rowLink">
										<b-link :href="'/share/'+rowLink.value" target="_blank">{{rowLink.value}}</b-link>
									</template>
									<template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
									
									<template v-slot:cell(share_data)="row">
										<!--{{JSON.parse(row.item.share_data)}}-->
										<b-row  class="item-list">
										<b-col cols="3" v-for="itemp in JSON.parse(row.item.share_data)" :key="itemp.id" class="mb-3 px-2 item-cell">
											 <!-- {{'kk1'+itemp.id}} -->
											 <!-- {{thumbnailProps}}-->
											 <div class="imgSh">
											<b-img-lazy  rounded blank-color="#f7f7f7" 				:src="$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+itemp.image" :alt="itemp.title" width="80px" height="80px"></b-img-lazy> 
											</div>
											<p>
											 <b-link :href="'/product/'+itemp.product_id" class="product-title text-capitalize">{{itemp.title}}</b-link>
											 </p>
											
						
						
											
										</b-col>
									</b-row>
									</template>
									<template v-slot:cell(rating)="row">
										<b-form-rating v-model="row.value" inline no-border readonly show-value show-value-max size="sm" variant="info"></b-form-rating>
									</template>
									<template v-slot:cell(actions1)="row">
										<span v-if='row.item.total_share==0'>Not Shared</span>
										<span v-else>Shared</span>
										<br />
										
										<b-badge pill variant="danger" v-if="row.item.activ_link == 0">Expired Link</b-badge>
										<b-badge pill variant="success" v-else>Active Link</b-badge>
										
									</template><template v-slot:cell(actions)="row">
										<!--<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>-->
										<b-button pill variant="outline-primary" class="mr-1 icon-btn"  @click="showShareModal(row.item, row.index, $event.target)" ><i class="fa fa-share-alt"></i></b-button>
										<!-- v-b-modal="'showShareModal'"  -->
										<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><i class="fa fa-trash" aria-hidden="true"></i></b-button>
										
										<!--b-button pill variant="danger" v-if="row.item.role!=1 && $root.chkperm('users','delete')" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>-->
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing 1 to 10 of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
			
				<!-- <b-modal id="showShareModal" hide-footer @hidden="resetSelectedItem">
				  <template #modal-title> Selected Products </template>
				  <div  class="selected-products-wrapper d-flex flex-wrap justify-content-between">
					<div class="product-wrapper d-flex justify-content-between" v-for="(product,idx) in selectedItem" :key="idx">
					  <div class="product-img-wrapper">
						<b-img-lazy v-bind="thumbnailPropsPop" rounded :src="$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+product.image" :alt="product.title" width="80px;"></b-img-lazy>
					  </div>
					  <div class="product-content-wrapper d-flex flex-column">
						<span class="product-title">{{product.title}}</span>
						<product-rating :userrating="product.total_rating"></product-rating>
						<a @click="removeBucket(idx)" class="remove-product-link">Remove</a>
					  </div>
					</div>
				  </div>
				  <div class="message-textarea-wrapper">
					<b-form-textarea v-model="linkComments"
					  id="message-textarea"
					  rows="4"
					  placeholder="Type your message here"
					></b-form-textarea>
				  </div>
				  <div
					class="product-share-wrapper d-flex justify-content-center align-items-ceter">
					<span class="product-share-txt align-self-center mr-4">Share Now</span>
									{{selectedLink}}
									{{linkComments}} 
					<b-row class="float-right">
						<b-col>
							<div class="icon-btn float-left margin-right-half" @click="shareSelectedProducts(item, 'sms')">
								<img src="../../assets/sms.svg"/>
							</div>
							<div class="icon-btn float-left margin-right-half">
								<ShareNetwork
									network="facebook"
									:url="'https://www.alluraa.com/share/'+selectedLink"
									title="Say hi to user."
									:description="linkComments"
									hashtags="Alluraa,test">
									<img src="../../assets/facebook.svg"/>
								</ShareNetwork>
							</div>
							<div class="icon-btn float-left margin-right-half">
								<ShareNetwork
									network="whatsapp"
									:url="'https://www.alluraa.com/share/'+selectedLink"
									title="Alluraa Products"
									:description="linkComments">
									<img src="../../assets/whatsapp.svg"/>
								</ShareNetwork>
							</div>
							<div class="icon-btn float-left margin-right-half">
								<ShareNetwork
									network="twitter"
									:url="'https://www.alluraa.com/share/'+selectedLink"
									title="New Test Alluraa Product."
									hashtags="Alluraa,test"
									twitter-user="">
									<img src="../../assets/twitter.svg"/>
								</ShareNetwork>
							</div>
						</b-col>
					</b-row>

					
				  </div>
				</b-modal>  -->

			<sharelik-popup :selectedItem="selectedItem"  :selectedLink="selectedLink" iamin="sharelinkpage"></sharelik-popup>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		
	</div>
	
</template>
<script>
//import Header from "@/components/agent/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/agent/nevleft.vue";
import SharelinkPopup from "@/components/sharelink-popup.vue";

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"sharelik-popup": SharelinkPopup,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		//var self = this;
		return{
		
			loading: true, 
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Users',
					active: true
				}
			],
			recordUrl: this.$root.WEBAPI+'agentapi/sharelink-record',
			updateUrl: this.$root.WEBAPI+'agentapi/sharelink-update',
			deleteUrl: this.$root.WEBAPI+'agentapi/sharelink-delete',
			records: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			user_roles: [],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'link_id', label: 'Link ID'},
				{ key: 'total_views', label: 'Views'},
				{ key: 'total_share', label: 'Shared'},
				{ key: 'share_data', label: 'Share Products', class:"colDisplaynone"},
				{ key: 'created_at', label: 'Created At',
					formatter: (value) => { 
							return this.$moment(value).format('DD-MM-YYYY');
							 
						},
				},
				{ key: 'actions1', label: 'Status', 'extra': 1, class:'text-right' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class:'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			selectedLink: '',
			linkComments: '',
			emptyItem: {}, 
			thumbnailProps: { blank: false, fluidGrow: true, width: 80, height: 80,class: 'm1' },
			thumbnailPropsPop: { blank: false, fluidGrow: true, width: 80, height: 80,class: 'm1' },
			bucket:[],
		};
	},
	methods: {
		
		redirectUrl(url){
			this.$router.push(url);
		},		
		showShareModal(item, index, button) {
			this.selectedItem = Object.assign({}, JSON.parse(item.share_data));
			this.selectedLink =item.link_id;
			//this.selectedItem.password = '';
			this.$root.share.socialSocial='';
			this.$root.$emit('bv::show::modal', 'showShareModal', button)
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Share Link.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					self.records = response.data.result.records;
					//self.user_roles = response.data.result.roles;
					self.loading = false;
					self.totalRows = self.records.length;
					
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
	}
}
</script>
<style   scoped lang="scss">
    /* .imgSh{width: 86%;
    height: 85px;
    border: 1px Solid #c6c6c6;
	} */
	
		

</style>
